import {SimpleEditor} from "./SimpleEditor.js";
import {Temp} from "../utils/Temp.js";


export class TextEditor extends SimpleEditor {
	constructor(parent, fieldPath, obj, member, widgetOptions) {
		super(parent, fieldPath, obj, member, widgetOptions);
	}

	rebuild() {
		this.widget = this.root = this.makeWidget();
		this.updateScreen();
		this.widget.on('input', function (e) {
			this.updateData();
		}.bind(this));
	}

	makeWidget() {
		return Temp.text(this.options);
	}

	enableWidget(enable) {
		if (enable) this.widget.removeAttr('readonly');
		else this.widget.attr('readonly', 'readonly');
	}

	displayError(problem) {
		super.displayError(problem);
	}

	clearError() {
		return super.clearError();
	}
}
